import { render, staticRenderFns } from "./lr.vue?vue&type=template&id=7388fc2f&"
import script from "./lr.vue?vue&type=script&lang=js&"
export * from "./lr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports